import { colorOf } from "@/lib/colors";

export const initials = (name) =>
  name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join("");

export const EmployeeAvatar = ({ employee, size = 32 }) => {
  const c = colorOf(employee);
  return (
    <span
      className="inline-flex shrink-0 items-center justify-center rounded-full font-display text-[11px] font-bold"
      style={{ width: size, height: size, background: "#fff", color: c.ink, boxShadow: `inset 0 0 0 2px ${c.accent}` }}
    >
      {initials(employee.name)}
    </span>
  );
};

export const EmployeeChip = ({ employee }) => {
  const c = colorOf(employee);
  return (
    <span className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium" style={{ background: c.bg, color: c.ink }}>
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: c.accent }} />
      {employee.name}
    </span>
  );
};
